require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-hayley-dacosta.json") })
        }
      }, "path---people-hayley-dacosta");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-hayley-dacosta!./.cache/json/people-hayley-dacosta.json
// module id = 1453
// module chunks = 231608221292675